import { useNavigate, useSearchParams } from 'react-router-dom';
import { RrcEp9WasteProfileInspector } from '@ots-frontend/ots-ui-tw';
export const RrcEp9WasteProfileProfilePageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcEp9WasteProfileProfilePage
      id={params.get('id') ?? undefined}
      tenantCode={params.get('tenantCode') ?? undefined}
    />
  );
};
export const RrcEp9WasteProfileProfilePage = ({
  id,
  tenantCode,
}: {
  id?: string;
  tenantCode?: string;
}) => {
  const navigate = useNavigate();
  return (
    <RrcEp9WasteProfileInspector
      id={id}
      tenantCode={tenantCode}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
